import { PRODUCT_TYPES } from '../enums/product-types';
import { PAGE_TYPES } from '../enums/page-types';
import checkIsFreeCheckout from './checkIsFreeCheckout';
import checkIsFreeEvent from './checkIsFreeEvent';
import getSelectedTicketTypes from '@repo/checkout/lib/getSelectedTicketTypes';

export default function checkShouldShowPriceBreakdown({
  pageType,
  productType,
  cartCost,
  productVariants,
  formVariants,
  pageTicketGroups,
}) {
  if (pageType === PAGE_TYPES.CHECKOUT) {
    if (productType === PRODUCT_TYPES.ONE_TIME) {
      const isFreeCheckout = checkIsFreeCheckout({
        amount: cartCost.totalAmount,
        productType: productType,
        productVariants: productVariants,
        formVariants: formVariants,
      });

      if (isFreeCheckout) {
        if (cartCost.subtotalAmount > 0 || cartCost.totalDueAmount > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        if (cartCost.subtotalAmount > 0 || cartCost.totalDueAmount > 0) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return true;
    }
  } else if (pageType === PAGE_TYPES.EVENT) {
    const isFreeEvent = checkIsFreeEvent({
      pageTicketGroups: pageTicketGroups,
    });

    const selectedTickets = getSelectedTicketTypes(pageTicketGroups, formVariants);
    const hasSelectedTickets = selectedTickets.length > 0;

    // Free event with no cost - no payment needed
    if (isFreeEvent && cartCost.totalDueAmount === 0) {
      return false;
    }

    // No tickets selected but event has paid options - show payment methods until a selection is made
    if (!hasSelectedTickets) {
      return true;
    }

    if (cartCost.subtotalAmount > 0 || cartCost.totalDueAmount > 0) {
      // show price breakdown if there's a cost (e.g. additional fees)
      return true;
    } else {
      // don't show price breakdown if there's no cost, only selected free tickets
      return false;
    }
  }
}
